module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-bd"
  }, [_c('div', {
    class: [("w-exception-" + (_vm.mode.mode)), 'w-exception']
  }, [_c('i', {
    staticClass: "bConfirm-close",
    on: {
      "click": function($event) {
        _vm.onClose()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cnt"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode.img0),
      expression: "mode.img0"
    }],
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.mode.img0
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode.txt0),
      expression: "mode.txt0"
    }],
    class: ['note-txt0', _vm.mode.txt1 ? '' : 'note-center'],
    domProps: {
      "innerHTML": _vm._s(_vm.mode.txt0)
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode.txt1),
      expression: "mode.txt1"
    }],
    staticClass: "note-txt1"
  }, [_c('bCheckbox', {
    attrs: {
      "label": _vm.mode.txt1,
      "name": _vm.mode.txt1
    },
    model: {
      value: (_vm.checkStatus),
      callback: function($$v) {
        _vm.checkStatus = $$v
      },
      expression: "checkStatus"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [(_vm.mode.btnTxt0) ? _c('div', {
    staticClass: "pop-btn",
    class: _vm.mode.btnTxt1 ? 'left' : 'center',
    on: {
      "click": _vm.modeClose
    }
  }, [_vm._v(_vm._s(_vm.mode.btnTxt0))]) : _vm._e(), _vm._v(" "), (_vm.mode.btnTxt1) ? _c('div', {
    staticClass: "pop-btn",
    class: [_vm.mode.btnTxt0 ? 'right' : 'center'],
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.mode.btnTxt1))]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b3fd008"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mode.vue
// module id = 507
// module chunks = 1